<template>
  <div class="row m-0 align-items-center">
    <div
        class="routes__icon"
        :class="{'routes__icon--small': small}"
        :style="{ backgroundColor: badgeColor }"
    >
      <RouteLogo :routeId="routeId" :color="badgeTextColor" />
    </div>
    <div
        class="ml-1 routes__name"
        :class="{'routes__name--small': small}"
        :style="{ backgroundColor: badgeColor, color: badgeTextColor }"
    >
      {{ routeName }}
    </div>
  </div>
</template>

<script>
import RouteLogo from "@/components/RouteLogo";
import {DEFAULT_ROUTE_COLOR, DEFAULT_ROUTE_TEXT_COLOR, routeColor, routeTextColor} from "@/utils";

export default {
  name: "RouteBadge",
  components: {
    RouteLogo
  },
  props: {
    routeId: {
      type: String,
      required: true
    },
    routeName: {
      type: String,
      required: true
    },
    routeColor: {
      type: String,
      default: DEFAULT_ROUTE_COLOR
    },
    routeTextColor: {
      type: String,
      default: DEFAULT_ROUTE_TEXT_COLOR
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    badgeColor() {
      return routeColor(this.routeColor);
    },
    badgeTextColor() {
      return routeTextColor(this.routeTextColor);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/__variables.scss";

.routes__icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 50%;
}

.routes__icon--small {
  width: 20px;
  height: 20px;

  svg {
    height: 12px;
  }
}

.routes__name {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: $radius1;
  font-weight: 700;
  height: 40px;
  min-width: 58px;
  text-align: center;
  justify-content: center;
  font-size: 22px;
}

.routes__name--small {
  height: 20px;
  min-width: 34px;
  font-size: 14px;
  padding: 2px 5px;
}
</style>
